/**
 * VendorProductRuleService
 * Service for managing vendor product rules
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor product rule CRUD operations with product-specific queries
 */
export class VendorProductRuleService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorProductRuleService.DEFAULT_SERVICE_PATH,
            basePath: VendorProductRuleService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all rules for a specific product
     * @param productId - Product ID
     * @returns Array of vendor product rule views
     */
    async getByProduct(productId) {
        const response = await this.getByProductRaw(productId);
        return response.data ?? [];
    }
    /**
     * Get all rules for a specific product with full response
     * @param productId - Product ID
     * @returns ResponseData with array of vendor product rule views
     */
    getByProductRaw(productId) {
        const url = this.buildUrl(`product/${productId}`);
        return this.http.get(url);
    }
}
VendorProductRuleService.DEFAULT_SERVICE_PATH = 'vendor-catalogs';
VendorProductRuleService.BASE_PATH = 'api/vendor-product-rules';
//# sourceMappingURL=VendorProductRuleService.js.map